<!-- <p>lodged-complaints-card works!</p> -->
<div class="mobile-table-card-wrapper">
  <div
    *ngFor="let complain of complaintList"
    class="mobile-table-card-container"
  >
    <div class="card-content">
      <div>
        {{ labelName }} Id : <b>{{ complain.complainId.split("-")[0] }}</b>
      </div>
      <div>
        {{ labelName }} Date :
        <b>{{
          getFormatedDate(complain.complainAddDate)
            | date : "dd/MM/yy, hh:mm:ss a'"
        }}</b>
      </div>
      <div>
        Subject :
        <b>{{ complain.complainSubject }} </b>
      </div>
      <div>
        Description :
        <b>{{ complain.complainDescription | truncateCase : 75 }}</b>
      </div>
    </div>
    <div class="card-action" *ngIf="complain.complainIncidentDetails">
      <button
        [ngStyle]="
          complain.complainIncidentDetails.incidentStatus == 3
            ? { 'background-color': '#ffbf00' }
            : complain.complainIncidentDetails.incidentStatus == 0
            ? { 'background-color': 'green' }
            : complain.complainIncidentDetails.incidentStatus == 1
            ? { 'background-color': 'red' }
            : {}
        "
        mat-flat-button
      >
        {{
          complain.complainIncidentDetails.incidentStatus == 1
            ? "Closed"
            : complain.complainIncidentDetails.incidentStatus == 0
            ? "Open"
            : complain.complainIncidentDetails.incidentStatus == 2
            ? "Verified"
            : complain.complainIncidentDetails.incidentStatus == 3
            ? "Snoozed"
            : complain.complainIncidentDetails.incidentStatus == 4
            ? "In-Progress"
            : complain.complainIncidentDetails.incidentStatus == 5
            ? "On-Hold"
            : complain.complainIncidentDetails.incidentStatus == 6
            ? "Approved"
            : complain.complainIncidentDetails.incidentStatus == 7
            ? "Rejected"
            : complain.complainIncidentDetails.incidentStatus == 8
            ? "Completed"
            : "Not Specified"
        }}
        <!-- {{
          complain.complainIncidentDetails.incidentStatus == 3
            ? "Snoozed"
            : "Snooze"
        }} -->
      </button>
      <button (click)="onShowDetails(complain)" mat-raised-button>
        {{ "Details" }}
      </button>
    </div>
  </div>
</div>
